import { useEffect, useMemo, useState } from "react";
import { useSettingsStore, useTasksStore } from "../../stores/index.js";
import { useCalendarNavStore } from "../../stores/calendarNav.store.js";
import { useViewFilters } from "../../lib/useViewFilters.js";
import { applyViewExclusions } from "../../lib/view-exclusions.js";
import { MonthGrid } from "../../features/calendar-view/MonthGrid.js";
import { CalendarHeader } from "../../features/calendar-view/CalendarHeader.js";
import { shiftAnchor } from "../../features/calendar-view/shift-anchor.js";
import { useMonthCells } from "../../features/calendar-view/useMonthCells.js";
import { MobileInboxDrawer } from "../../features/mobile/index.js";
import { useMobileUx } from "../../lib/useMobileUx.js";
import { useCalendarNav, useRememberedCalendarAnchor } from "./useCalendarNav.js";

export function MonthRoute() {
  const [anchor, setAnchor] = useRememberedCalendarAnchor("month", () => new Date());
  const [inboxOpen, setInboxOpen] = useState(false);
  const mobile = useMobileUx();
  const tasks = useTasksStore((s) => s.tasks);
  const rules = useTasksStore((s) => s.rules);
  const overrides = useTasksStore((s) => s.overrides);
  const loaded = useTasksStore((s) => s.loaded);
  const hydrate = useTasksStore((s) => s.hydrate);
  const applyFilters = useViewFilters();
  const weekStartsOn = useSettingsStore((s) => s.weekStartsOn);
  const excludedTopicIds = useSettingsStore((s) => s.monthExcludedTopicIds);
  const excludedCalendarIds = useSettingsStore((s) => s.monthExcludedCalendarIds);
  const setStep = useCalendarNavStore((s) => s.setStep);
  useEffect(() => { if (!loaded) void hydrate(); }, [loaded, hydrate]);
  useEffect(() => {
    setStep((delta) => setAnchor((prev) => shiftAnchor(prev, "month", delta)));
    return () => setStep(null);
  }, [setStep]);
  useCalendarNav("month", setAnchor);

  const filtered = useMemo(
    () => applyViewExclusions(applyFilters(tasks), { topicIds: excludedTopicIds, calendarIds: excludedCalendarIds }),
    [applyFilters, tasks, excludedTopicIds, excludedCalendarIds],
  );
  const cells = useMonthCells(anchor, filtered, rules, overrides, weekStartsOn);
  return (
    <div className={`flex h-full min-h-0 flex-col ${mobile ? "" : "gap-4"}`}>
      <CalendarHeader anchor={anchor} onChange={setAnchor} unit="month" />
      <MonthGrid anchor={anchor} cells={cells} onMonthShift={(delta) => setAnchor((prev) => shiftAnchor(prev, "month", delta))} />
      {mobile && <MobileInboxDrawer open={inboxOpen} onOpenChange={setInboxOpen} />}
    </div>
  );
}
